module.exports = __webpack_public_path__ + "static/1_1_defineai_HR-901f3a020ac64475e4836e596adce3f5.svg";